import { useEffect } from 'react';

const FaviconManager = () => {
  useEffect(() => {
    // Function to set favicon
    const setFavicon = () => {
      const faviconPath = `${process.env.PUBLIC_URL}/assets/Virtual Triage.png`;
      const timestamp = new Date().getTime();
      
      // Remove any existing favicon links
      const existingLinks = document.querySelectorAll('link[rel*="icon"]');
      existingLinks.forEach(link => link.remove());
      
      // Create new favicon links
      const sizes = ['16x16', '32x32', '192x192', '512x512'];
      sizes.forEach(size => {
        const link = document.createElement('link');
        link.rel = 'icon';
        link.type = 'image/png';
        link.sizes = size;
        link.href = `${faviconPath}?v=${timestamp}`;
        document.head.appendChild(link);
      });
      
      // Add apple touch icon
      const appleTouchIcon = document.createElement('link');
      appleTouchIcon.rel = 'apple-touch-icon';
      appleTouchIcon.sizes = '180x180';
      appleTouchIcon.href = `${faviconPath}?v=${timestamp}`;
      document.head.appendChild(appleTouchIcon);
      
      // Add shortcut icon
      const shortcutIcon = document.createElement('link');
      shortcutIcon.rel = 'shortcut icon';
      shortcutIcon.href = `${faviconPath}?v=${timestamp}`;
      document.head.appendChild(shortcutIcon);
    };
    
    // Set favicon when component mounts
    setFavicon();
    
    // Also set favicon when route changes
    const handleRouteChange = () => {
      setTimeout(setFavicon, 100); // Small delay to ensure DOM is ready
    };
    
    // Listen for popstate events (browser back/forward)
    window.addEventListener('popstate', handleRouteChange);
    
    // Listen for custom route change events
    const handleCustomRouteChange = () => {
      setTimeout(setFavicon, 100);
    };
    
    // Add event listener for route changes
    window.addEventListener('routeChange', handleCustomRouteChange);
    
    // Cleanup
    return () => {
      window.removeEventListener('popstate', handleRouteChange);
      window.removeEventListener('routeChange', handleCustomRouteChange);
    };
  }, []);
  
  return null; // This component doesn't render anything
};

export default FaviconManager; 